import { makeStyles } from "@material-ui/core";

const minAccordionStyle = makeStyles({
  expanded: {
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: 0
    },
  },
  summarySmall: {
    paddingLeft: 0,
    paddingRight: 0,
    minHeight: '0px !important'
  },
})

export { minAccordionStyle }